import axios from 'axios';
import authHeader from "./auth-header";
import {config} from "../constants";

class AccountService {

    license() {
        return axios.get(config.API_URL + "account/license", {headers: authHeader()})
    }

    matchAlertSettings() {
        return axios.get(config.API_URL + "account/match-alert-settings", {headers: authHeader()});
    }

    toggleMatchAlert(matchAlertEnabled) {
        return axios.post(config.API_URL + "account/toggle-match-alert/" + matchAlertEnabled, null, {headers: authHeader()});
    }

    settingsSave(data) {
        return axios.post(config.API_URL + "account/match-alert-settings-save", data, {headers: authHeader()});
    }

    removeLicense() {
        localStorage.removeItem("license")
    }

    getLicense() {
        // return JSON.parse(localStorage.getItem("license"))
        return null
    }

    saveLicense(license) {
        // localStorage.setItem("license", JSON.stringify(license))
    }

    reduceSearchCount() {

        const license = this.getLicense()
        if (license) {
            license.remainingSearchCount -= 1
            localStorage.setItem("license", JSON.stringify(license))
        }
    }

}

export default new AccountService();
